module.exports = __webpack_public_path__ + "img/ip360_position_img.a8465c64.png";